import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { styled } from '@thg-commerce/gravity-theme'
import {
  CarouselI18nText,
  AmpCarouselProps,
} from '@thg-commerce/gravity-patterns/Carousel/types'
import { Image } from '@thg-commerce/gravity-elements/Image'
import { ImageProps } from '@thg-commerce/gravity-elements/Image/Image'
import {
  Carousel,
  CarouselButtonPlacement,
} from '@thg-commerce/gravity-patterns'

export interface ImageCarouselRendererProps {
  items: Omit<ImageProps, 'isAmp'>[]
  isAmp: boolean
}

const StyledImage = styled(Image)`
  background-color: transparent;
`

export const ImageCarouselRenderer = ({
  items,
  isAmp,
}: ImageCarouselRendererProps) => {
  const carouselText: CarouselI18nText = {
    leftScrollLabel: i18n('carousel.controls.left.arialabel'),
    rightScrollLabel: i18n('carousel.controls.right.arialabel'),
  }

  const ampProps: AmpCarouselProps = {
    height: 500,
    width: 300,
    type: 'slides',
    role: 'region',
  }

  const imageComponents = items.map((image, index) => {
    return (
      <StyledImage
        src={image.src}
        width="100%"
        height="330px"
        alt={image.alt || ''}
        isAmp={isAmp}
        imageStyle="contain"
        key={index}
      />
    )
  })

  return (
    <Carousel
      data-testid={'image-carousel-element'}
      items={imageComponents}
      itemsPerSlide={[1]}
      i18n={carouselText}
      isAmp={isAmp}
      ampProps={ampProps}
      hideSlidePreview={true}
      buttonPlacement={CarouselButtonPlacement.Split}
    />
  )
}
